<template>
  <div :class="[$style.toast_icon, isClose ? $style.close : $style.icon]">
    <sprite
      :key="'toast_icon_' + iconProps.name"
      class="svg"
      :name="iconProps.name"
      :type="iconProps.type"
      :style="{ color: iconProps.color }"
    />
  </div>
</template>

<script>
import { TYPE } from 'vue-toastification';
import sprite from '$$uiKitComp/VueIcon/svgSprite.vue';

export default {
  name: 'ToastIcon',
  components: {
    sprite,
  },
  props: {
    type: {
      type: String,
      required: true,
      default: TYPE.INFO,
      validator(value) {
        return [TYPE.SUCCESS, TYPE.INFO, TYPE.WARNING, TYPE.ERROR, 'close'].includes(value);
      },
    },
  },
  emits: ['click'],
  computed: {
    isClose() {
      return this.type === 'close';
    },
    iconProps() {
      switch (this.type) {
        case TYPE.SUCCESS: return { name: 'success', type: 'bold', color: '#00564C' };
        case TYPE.WARNING: return { name: 'warning-1', type: 'bold', color: '#FF9A00' };
        case TYPE.ERROR: return { name: 'close-2', type: 'bold', color: '#DD3636' };
        case 'close': return { name: 'close-1', type: 'regular', color: '#B2B2B2' };
        default: return { name: 'info', type: 'bold', color: '#1565C0' };
      }
    },
  },
};
</script>

<style module lang="less" src="./toast.less"></style>
